var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinux({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/linux"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 21s3-5.478 3-11.74a6.4 6.4 0 0 1 1.757-4.426A5.876 5.876 0 0 1 12 3a5.88 5.88 0 0 1 4.243 1.834A6.402 6.402 0 0 1 18 9.26C18 15.52 21 21 21 21m-6-7.043-3 1.933-3-1.934M8.1 21a4.61 4.61 0 0 1 1.65-1.716 4.365 4.365 0 0 1 2.25-.627c.79 0 1.566.216 2.25.627A4.61 4.61 0 0 1 15.9 21M9.813 9.445c.458 0 .829.206.829.46 0 .255-.371.46-.829.46-.457 0-.828-.205-.828-.46 0-.254.37-.46.828-.46Zm4.328 0c.457 0 .828.206.828.46 0 .255-.37.46-.828.46-.458 0-.829-.205-.829-.46 0-.254.371-.46.829-.46Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinux);
export default __webpack_public_path__ + "static/media/linux.64f26c89ce592d89a2af9e53b4e18ac8.svg";
export { ForwardRef as ReactComponent };